export const FETCHID = 'FETCHID';
export const CHANGEID = 'CHANGEID';

export const FETCHUSER = 'FETCHUSER';
export const CHANGEUSER = 'CHANGEUSER';

//IMPORTANT YOU CANNOT USE THE SAME NAME TO DO DIFFERENT FUNCTIONS! EACH FUNCTION SHOULD HAVE IT'S UNIQUE NAME!